<template>
  <form @submit.prevent="">
    <z-dialog :show="isVisible" :modal-size="modalSize">
      <template #header>
        <div class="custom-header">
          <div class="row">
            <div class="col-md-11">
              <h4 class="modal-title">
                {{ title }}
              </h4>
            </div>
            <div class="col-md-1">
              <a href="#" class="custom-close" @click="close">
                <i class="fa fa-times"></i>
              </a>
            </div>
          </div>
        </div>
      </template>
      <template #body>
        <div class="row">
          <div class="col">
            <span class="custom-header-label">{{ location }}</span>
          </div>
        </div>
        <div class="row mt-4">
          <div class="col-6">
            <div class="form-group">
              <label for="firm" class="form-label">Firm Id (LaunchPad)</label>
              <input id="firm" v-model="firm" type="text" class="form-control" />
            </div>
          </div>
          <div class="col-6">
            <div class="form-group">
              <label for="appFirm" class="form-label">App Firm Id</label>
              <input id="appFirm" v-model="appFirm" type="text" class="form-control" />
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <div class="form-group">
              <label for="acctId" class="form-label">Account Id</label>
              <input id="acctId" v-model="id" type="text" class="form-control" />
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <div class="form-group">
              <label for="acctKey" class="form-label">Account Key</label>
              <input id="acctKey" v-model="key" type="text" class="form-control" />
            </div>
          </div>
        </div>
        <div class="row mt-2">
          <div class="col">
            <div class="form-group">
              <label for="source" class="form-label me-2">Partner:</label>
              <span id="source">{{ source }}</span>
            </div>
          </div>
        </div>
      </template>
      <template #footer>
        <div class="custom-footer">
          <div class="col"></div>
          <div class="col custom-right-align">
            <button type="button" class="btn btn-light" @click="close()">Cancel</button>
            <button v-show="isSave" class="btn btn-danger ms-2" @click="save(false)">Save</button>
          </div>
        </div>
      </template>
    </z-dialog>
  </form>
</template>
<script>
import { mapState, mapActions } from 'pinia'
import { wasabiStore } from '@/stores/wasabi'
import ZDialog from '@/components/utilities/elements/Dialog.vue'
export default {
  name: 'DialogAdd',
  components: {
    ZDialog
  },
  props: {
    modelValue: Object,
    showFirm: Object
  },
  emits: ['closing', 'saved'],
  data() {
    return {
      modalSize: 'modal-md',
      isSave: false
    }
  },
  computed: {
    ...mapState(wasabiStore, ['account']),
    isVisible() {
      return this.modelValue !== null
    },
    title() {
      let _title = 'Edit Wasabi Account'
      return _title
    },
    location() {
      return this.account.firmName
    },
    source() {
      let _source = null
      if (this.account) {
        if (this.account.source === 'Calibrate' || this.account.source === 'TestDrive') {
          _source = `Legacy - ${this.account.source}`
        } else {
          _source = this.account.source.replace('Calibrate', '').replace('TestDrive', '')
        }
      }
      return _source
    },
    firm: {
      get() {
        return this.account.firm
      },
      set(value) {
        this.isSave = true
        this.setAccount({
          name: 'firm',
          value: value
        })
      }
    },
    appFirm: {
      get() {
        return this.account.appFirm
      },
      set(value) {
        this.isSave = true
        this.setAccount({
          name: 'appFirm',
          value: value
        })
      }
    },
    id: {
      get() {
        return this.account.acctId
      },
      set(value) {
        this.isSave = true
        this.setAccount({
          name: 'acctId',
          value: value
        })
      }
    },
    key: {
      get() {
        return this.account.acctKey
      },
      set(value) {
        this.isSave = true
        this.setAccount({
          name: 'acctKey',
          value: value
        })
      }
    }
  },
  methods: {
    ...mapActions(wasabiStore, ['setAccount', 'saveAccount']),
    close() {
      this.isSave = false
      this.$emit('closing')
    },
    async save() {
      if (this.isSave) {
        await this.saveAccount()
        this.isSave = false
        this.$emit('saved', this.account.acctNum)
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.custom-header {
  width: 100%;
}
.custom-close {
  float: right;
  margin-right: 10px;
  color: #000;
  cursor: pointer;
}
.custom-footer {
  width: 100%;
  display: inline-flex;
}
.hostWrapper {
  max-height: 650px;
  overflow-x: hidden;
  overflow-y: auto;
  height: 600px;
}
.custom-header-label {
  font-weight: 600;
}
</style>
